import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useAsync } from 'react-use'

import { Form as AntdForm, Card, Col, Row, Input, Button, Skeleton, Select } from 'antd'
import { PlusOutlined } from '@ant-design/icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// import _ from 'lodash'

import { useAuth } from '../../../contexts/AuthContextProvider'

const Form = () => {
  const navigate = useNavigate()
  const { db } = useAuth()
  const { containerId } = useParams()
  const [btnLoading, setBtnLoading] = useState(false)
  const { value, loading } = useAsync(async () => {
    if (!containerId) {
      return {
        answer: [
          {
            type: ''
          }
        ]
      }
    } else {
      const snap = await db.collection('container').doc(containerId).get()
      return {
        ...snap.data(),
        id: snap.id,
        answer: [
          {
            type: snap.type,
            status: snap.status
          }
        ]
      }
    }
  }, [containerId])
  const mode = containerId ? 'Submit' : 'Create'
  const handleSubmit = async (formData) => {
    const batch = db.batch()
    console.log(formData, 'formData')
    try {
      setBtnLoading(true)
      if (containerId) {
        formData.answer.forEach((o) => {
          batch.set(db.collection('container').doc(containerId), { ...o })
        })
      } else {
        formData.answer.forEach((o) => {
          batch.set(db.collection('container').doc(), { ...o })
        })
      }
      await batch.commit()
      navigate('/admin/master-data/container/list')
    } catch {
      setBtnLoading(false)
    }
  }
  if (loading) return <Skeleton />

  return (
    <AntdForm
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={value}
    >
      <Card
        title="Container"
        headStyle={{ fontWeight: 'bold', fontSize: '20px', lineHeight: '23px', backgroundColor: '#CFE2FF', color: '#154D9F' }}
        bodyStyle={{ boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.1)', borderRadius: '0 0 10px 10px' }}
      >
        <Row>
          <Col span={6}></Col>
          <Col span={14}>
            <AntdForm.List name="answer">
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field) => (
                    <Row gutter={[32, 0]} key={field.key}>
                      <Col span={10}>
                        <AntdForm.Item
                          {...field}
                          name={[field.name, 'type']}
                          label="Answer"
                          fieldKey={[field.fieldKey, 'type']}
                          initialValue={value.type}
                          rules={[{ required: true, message: 'Answer cannot be blank' }]}
                        >
                          <Input />
                        </AntdForm.Item>
                      </Col>
                      <Col span={10}>
                        <AntdForm.Item
                          label="Status"
                          fieldKey={[field.fieldKey, 'status']}
                          name={[field.name, 'status']}
                          initialValue={mode === 'Create' ? 'Active' : value.status}
                        >
                          <Select style={{ height: '40px', borderRadius: '8px' }}>
                            <Select.Option value="Active">Active</Select.Option>
                            {containerId &&
                              <Select.Option value="InActive">InActive</Select.Option>
                            }
                          </Select>
                        </AntdForm.Item>
                      </Col>
                      {mode === 'Create' &&
                        <Col span={4}>
                          <Button style={{ marginTop: '40px', width: '42px', height: '40px', borderRadius: '4px', backgroundColor: '#EA3939', color: '#FFF' }} onClick={() => remove(field.name)} icon={<FontAwesomeIcon icon={faTrashAlt} />}></Button>
                        </Col>
                      }
                    </Row>
                  ))}
                  {mode === 'Create' &&
                    <Row justify="center" style={{ marginTop: '20px' }}>
                      <AntdForm.Item>
                        <Button style={{ marginRight: '120px', width: '150px', borderRadius: '8px' }} disabled={mode === 'Submit'} type="primary" onClick={() => add()}><PlusOutlined />Add Answer</Button>
                      </AntdForm.Item>
                    </Row>
                  }
                </>
              )}
            </AntdForm.List>
            <Row justify="center" style={{ marginTop: '20px' }}>
              <Button style={{ marginRight: '120px', width: '300px', height: '40px', borderRadius: '8px' }} type="primary" loading={btnLoading} htmlType="submit">{mode}</Button>
            </Row>
          </Col>
          <Col span={4}></Col>
        </Row>
      </Card>
    </AntdForm>
  )
}
export default Form
